import React from "react";

const NumbersThatMatterSection = () => {
  const stats = [
    {
      number: "150+",
      label: "Projects Completed",
    },
    {
      number: "50+",
      label: "Happy Clients",
    },
    {
      number: "8+",
      label: "Years Experience",
    },
    {
      number: "24/7",
      label: "Support Available",
    },
  ];

  return (
    <div className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <div className="inline-block px-4 py-1.5 bg-blue-100 text-blue-600 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            OUR IMPACT
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Numbers That Matter
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto">
            Our commitment to excellence is reflected in the work we deliver and
            the relationships we build.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-10 text-center text-white shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-2 sm:mb-3">
                {stat.number}
              </div>
              <div className="text-xs sm:text-sm md:text-base font-medium opacity-90">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NumbersThatMatterSection;
